<template>
	<div class="contentbox">
		<div class="media-add-ep-list">
			<div class="caretbtn" @click="changeCaret(fromIsOpen)">
				<span>{{ fromIsOpen ? '展开' : '收起' }}</span>
				<i class="el-icon-caret-bottom" v-if="fromIsOpen"></i>
				<i class="el-icon-caret-top" v-else></i>
			</div>
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<div :class="fromIsOpen ? 'from-close' : ''">
						<el-form-item label="用户ID" prop="userId">
							<el-input v-model="formInline.userId" placeholder="请输入用户ID" clearable
								@keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
						</el-form-item>
						<el-form-item label="订单号" prop="orderId">
							<el-input v-model="formInline.orderId" placeholder="请输入订单号" clearable
								@keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
						</el-form-item>
						<el-form-item label="渠道订单号" prop="outDitchOrderId">
							<el-input v-model="formInline.outDitchOrderId" placeholder="请输入渠道订单号"
								@keyup.enter.native="search" @clear="search" clearable style="width: 200px;"></el-input>
						</el-form-item>
						<el-form-item label="支付状态" prop="status">
							<el-select v-model="formInline.status" placeholder="请选择支付状态" clearable @change="search"
								style="width: 200px;">
								<el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<!--<el-form-item label="广告计划ID" prop="nickName">-->
						<!--<el-input v-model="formInline.nickName" placeholder="请输入昵称" style="width: 200px;"></el-input>-->
						<!--</el-form-item>-->
						<el-form-item label="投放链接ID" prop="tfId">
							<el-input v-model="formInline.tfId" placeholder="请输入投放链接ID" clearable
								@keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
						</el-form-item>
						<el-form-item label="系统类型" prop="mos" style="margin-right: 30px;">
							<el-select v-model="formInline.mos" placeholder="请选择系统类型" clearable @change="search"
								style="width: 200px;">
								<el-option v-for="item in mosOptions" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<!--<el-form-item label="广告计划ID" prop="promotionId">-->
							<!--<el-input v-model="formInline.promotionId" placeholder="请输入广告计划ID" clearable-->
								<!--@keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>-->
						<!--</el-form-item>-->
						<el-form-item label="广告ID" prop="projectId">
							<el-input v-model="formInline.projectId" placeholder="请输入广告项目ID" clearable
								@keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
						</el-form-item>
						<el-form-item label="充值类型" prop="rechargeType">
							<el-select v-model="formInline.rechargeType" placeholder="请选择充值类型" clearable
								@change="search" style="width: 200px;">
								<el-option v-for="item in rechargeTypeOptions" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="充值来源" prop="bookName">
							<el-input v-model="formInline.bookName" placeholder="请输入充值来源" clearable
								@keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
						</el-form-item>
						<el-form-item label="时间：">
							<!--<el-date-picker v-model="dataTime" class="pickerData" format="yyyy-MM-dd"-->
								<!--value-format="yyyy-MM-dd" type="daterange" unlink-panels range-separator="至"-->
								<!--start-placeholder="开始日期" end-placeholder="结束日期" style="margin-right: 10px; width: 300px"-->
								<!--clearable @change="search">-->
							<!--</el-date-picker>-->
							<el-date-picker v-model="dataTime" class="pickerData" format="yyyy-MM-dd HH:mm:ss"
											value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" unlink-panels range-separator="至"
											start-placeholder="开始日期" end-placeholder="结束日期" style="margin-right: 10px; width: 400px"
											clearable @change="search">
							</el-date-picker>
						</el-form-item>
					</div>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="success" icon="el-icon-download" @click="exportex">导出</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height >
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="用户信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>用户ID：{{ scope.row.id }}</p>
								<p>昵称：{{ scope.row.nickName }}</p>
								<p>注册时间：{{ scope.row.strAddTime }}</p>
								<p>用户系统类型：{{ scope.row.mos }}</p>
								<p>累计成功充值笔数：{{ scope.row.times }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="支付状态" width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.status == 0" class="danger-text">未成功</span>
							<span v-if="scope.row.status == 1" class="succes-text">已支付</span>
							<span v-if="scope.row.status == 2" class="primary-text">未充值</span>
							<span v-if="scope.row.status == 3" class="warnning-text">已退款</span>
						</template>
					</el-table-column>
					<el-table-column label="充值信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>平台：{{ scope.row.platformPay }}</p>
								<p>渠道：{{ scope.row.channelPay }}</p>
								<p>充值金额：{{ scope.row.rechargeAmount }}</p>
								<p>实付金额：{{ scope.row.rechargeAmount }}</p>
								<p>支付单号：{{ scope.row.orderId }}</p>
								<p>渠道订单号：{{ scope.row.outDitchOrderId }}</p>
								<p>商户订单号：{{ scope.row.merchantOrderId }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="充值类型" width="120">
						<template slot-scope="scope">
							<p v-if="scope.row.rechargeType == 1">普通会员</p>
							<!-- <p v-if="scope.row.rechargeType == 1">月度会员</p> -->
							<p v-if="scope.row.rechargeType == 2">
								连续续费会员
							</p>
						</template>
					</el-table-column>
					<el-table-column label="签约类型" width="120">
						<template slot-scope="scope">
							<p v-if="scope.row.rechargeType == 2">
								<span v-if="scope.row.signingType === 1">连续包月</span>
								<span v-if="scope.row.signingType === 2">连续包季</span>
							</p>
							<p v-else>
								无
							</p>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="小程序信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>appid: {{ scope.row.appId }}</p>
								<p>小程序名称: {{ scope.row.appName }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="推广信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>推广平台：{{ scope.row.promotionPlatform }}</p>
								<p>投放链接：{{ scope.row.tfId }}</p>
								<p>充值来源：{{ scope.row.bookName }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="其他信息">
						<template slot-scope="scope">
							<div class="td-info">
								<!--<p>clickID：{{scope.row.tfId}}</p>-->
								<!--<p>广告计划ID：{{ scope.row.promotionId }}</p>-->
								<p>广告ID：{{ scope.row.projectId }}</p>
								<p>充值时间：{{ scope.row.strRechargeTime }}</p>
								<p v-if="scope.row.rechargeType == 1">
									{{ scope.row.durationType == 1 ? '月度会员' : scope.row.durationType == 4 ? '季度会员' :
									scope.row.durationType == 2 ? '年度会员' : '' }}
								</p>
								<p>会员结束时间：{{ scope.row.strEndTime }}</p>
								<!-- <p>充值说明：{{scope.row.rechargeBalance - scope.row.present}}金币 + {{scope.row.present}}赠币</p> -->
								<p>充值说明：{{ scope.row.rechargeInfo }}</p>
								<!--<p>是否回传：{{scope.row.tfId}}</p>-->
								<p v-if="scope.row.rechargeType == 2">是否签约后首单：{{ scope.row.firstOrder == 1 ? '签约后首单扣款' : scope.row.firstOrder == 0 ? '非签约后首单扣款' : '' }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="200">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini"
								@click="handleLook(scope.row.orderId)">详情</el-button>
							<el-dropdown v-has="'recharge:more'" trigger="click" style="margin-left: 10px;">
								<el-button type="success" size="mini">
									更多<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item :disabled="scope.row.status != 1"
										@click.native="handleRefund(scope.row.orderId)">退款</el-dropdown-item>
									<!--<el-dropdown-item :disabled="scope.row.status != 1 && scope.row.status != 3" @click.native="handleAddVid(scope.row.id)">回传</el-dropdown-item>-->
									<el-dropdown-item :disabled="scope.row.processNumber != 0 && scope.row.status != 2"
										@click.native="handleDelete(scope.row.orderId)">删除订单</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
				<div class="total-box">
					<span>总充值：{{totalAmount}} &nbsp;&nbsp;&nbsp;&nbsp;</span>
					<span>充值人数：{{users}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
					<span>充值笔数：{{orders}}</span>
                </div>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background
						:current-page="currentPage" layout="sizes, prev, pager, next, jumper, ->, total"
						:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td width="200">用户信息</td>
						<td>
							<p>用户ID：{{ rowFrom.id }}</p>
							<p>昵称：{{ rowFrom.nickName }}</p>
							<p>注册时间：{{ rowFrom.strAddTime }}</p>
							<p>用户系统类型：{{ rowFrom.mos }}</p>
							<p>累计成功充值笔数：{{ rowFrom.times }}</p>
						</td>
					</tr>
					<tr>
						<td>支付状态</td>
						<td>
							<span v-if="rowFrom.status == 0" class="danger-text">未成功</span>
							<span v-if="rowFrom.status == 1" class="succes-text">已支付</span>
							<span v-if="rowFrom.status == 2" class="primary-text">未充值</span>
							<span v-if="rowFrom.status == 3" class="warnning-text">已退款</span>
						</td>
					</tr>
					<tr>
						<td>充值信息</td>
						<td>
							<p>平台：{{ rowFrom.platformPay }}</p>
							<p>渠道：{{ rowFrom.channelPay }}</p>
							<p>充值金额：{{ rowFrom.rechargeAmount }}</p>
							<p>实付金额：{{ rowFrom.rechargeAmount }}</p>
							<p>支付单号：{{ rowFrom.orderId }}</p>
							<p>渠道订单号：{{ rowFrom.outDitchOrderId }}</p>
							<p>商户订单号：{{ rowFrom.merchantOrderId }}</p>
						</td>
					</tr>
					<tr>
						<td>小程序信息</td>
						<td>
							<p>appid: {{ rowFrom.appId }}</p>
							<p>小程序名称: {{ rowFrom.appName }}</p>
						</td>
					</tr>
					<tr>
						<td>推广信息</td>
						<td>
							<p>推广平台：{{ rowFrom.promotionPlatform }}</p>
							<p>投放链接：{{ rowFrom.tfId }}</p>
							<p>充值来源：{{ rowFrom.bookName }}</p>
						</td>
					</tr>
					<tr>
						<td>其他信息</td>
						<td>
							<p>广告计划ID：{{ rowFrom.promotionId }}</p>
							<p>广告项目ID：{{ rowFrom.projectId }}</p>
							<p>充值时间：{{ rowFrom.strRechargeTime }}</p>
							<!-- <p>充值说明：{{rowFrom.rechargeBalance}}金币 + {{rowFrom.present}}赠币</p> -->
							<p>充值说明：{{ rowFrom.rechargeInfo }}</p>
						</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-->
		<el-dialog title="输入退款金额" :visible.sync="dialogFormVisible" width="650px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350"
				style="max-height: 480px;overflow: auto; padding-right: 20px;">
				<el-form-item label="金币余额：" prop="balance">
					<el-input type="number" v-model="ruleForm.balance" placeholder="请输入金币余额"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { listRecharge, details, del, refund } from "@/api/wb/user/recharge";
export default {
	data() {
		var validateNum = (rule, value, callback) => {
			if (!(/(^[1-9]\d*$)/.test(value))) {
				return callback(new Error('数字应为正整数'));
			} else {
				callback();
			}
		};
		return {
			dataTime: [this.getDataTime(new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000)), this.getDataTimeEnd(new Date())],
			formInline: {
				appId: localStorage.getItem('appId'),
				userId: '',
				orderId: '',
				mos: '',
				outDitchOrderId: '',
				status: '',
				tfId: '',
				promotionId: '',
				rechargeStartDate: '',
				rechargeEndDate: '',
				rechargeType: '',
				projectId: '',
				bookName: ''
			},
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			dialogFormVisible: false,
			mosOptions: [{
				value: 'iOS',
				label: 'iOS'
			}, {
				value: 'android',
				label: 'android'
			}],
			statusOptions: [
				{
					value: 0,
					label: '未成功'
				},
				{
					value: 1,
					label: '已支付'
				},
				{
					value: 2,
					label: '未充值'
				},
				{
					value: 3,
					label: '已退款'
				}
			],
			rowFrom: {},
			dialogInfoVisible: false,
			ruleForm: {
				id: "",
				nickName: "",
				balance: '',
				tel: ''
			},
			rules: {
				epPrice: [
					{ required: true, message: '请输入退款金额', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
			},
			rechargeTypeOptions: [
                {
                    value: 1,
                    label: '普通会员'
                },
                {
                    value: 2,
                    label: '连续订阅会员'
                }
			],
			isAgent: false,
			fromIsOpen: false,
			users:0,
			totalAmount:0,
			orders:0,
		}
	},
	computed: {},
	watch: {
	},
	mounted: function () {
		if (this.$route.query.id) {
			this.formInline.tfId = this.$route.query.id
		}
		if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isAgent = true
			this.formInline.appId = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
		}
		this.getTableData()
	},
	methods: {
		// 从组件获取appid
		getAppId(data) {
			this.formInline.appId = data
			this.getTableData()
		},
		getCurrentDate(now) {
			// let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			return year + '-' + month + '-' + day;
		},
        getDataTime(time) {
            var date = new Date(time)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? '0' + m : m
            var d = date.getDate()
            d = d < 10 ? '0' + d : d
            var h = date.getHours()
            h = h < 10 ? '0' + h : h
            var minute = date.getMinutes()
            minute = minute < 10 ? '0' + minute : minute
            var s = date.getSeconds()
            s = s < 10 ? '0' + s : s
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
        },
        getDataTimeEnd(time) {
            var date = new Date(time)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? '0' + m : m
            var d = date.getDate()
            d = d < 10 ? '0' + d : d
            return y + '-' + m + '-' + d + ' ' + 23 + ':' + 59 + ':' + 59
        },
		search () {
			this.currentPage = 1
			this.getTableData()
		},
		resetQuery: function () {
			this.$refs['formInline'].resetFields()
			this.dataTime = []
			this.getTableData()
		},
		// pageSize切换
		handleSizeChange(val) {
			this.tableData.pageSize = val
			this.currentPage = 1
			this.getTableData()
		},
		handleCurrentChange(value) {
			this.currentPage = value
			this.getTableData()
		},
		handleLook(id) {
			console.log(id)
			this.dialogInfoVisible = true
			this.getDetails(id)
		},
		// 删除
		handleDelete(id) {
			console.log(id)
			this.$confirm('确定删除该订单?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				del({
					orderId: id
				}).then(response => {
					if (response.data.head.flag === 0) {
						if (this.tableData.result.length === 1 && this.currentPage > 1) {
							this.currentPage = this.currentPage - 1
						}
						this.getTableData()
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		// 退款
		handleRefund(id) {
			this.$confirm('确定退款该订单?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				refund({
					orderId: id,
				}).then(response => {
					if (response.data.head.flag === 0) {
						this.$message({
							type: 'success',
							message: '退款成功!'
						});
						this.getTableData()
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消退款'
				});
			});
		},
		// 获取详情
		getDetails(id) {
			details({
				orderId: id,
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.rowFrom = response.data.content
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 弹框确定
		editDialogSureBtn(formName) {
			console.log(this.ruleForm)
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log(this.ruleForm.updateType)
					// this.saveTableData()
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		getTableData() {
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
			console.log(this.dataTime)
			this.formInline.rechargeStartDate = this.dataTime ? this.dataTime[0] : ''
			this.formInline.rechargeEndDate = this.dataTime ? this.dataTime[1] : ''
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			console.log("paramJson", paramJson)
			listRecharge(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.orders = response.data.content.orders,
					this.totalAmount = response.data.content.totalAmount,
					this.users = response.data.content.users,
					this.tableData = response.data.content.page
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		//导出
		exportex() {
			console.log("导出")
			if (this.tableData.result.length > 0) {
				let url = '/short/novel/recharge/export?appId=' + this.formInline.appId + '&mos=' + this.formInline.mos + '&orderId=' + this.formInline.orderId + '&outDitchOrderId=' + this.formInline.outDitchOrderId + '&projectId=' + this.formInline.projectId + '&promotionId=' + this.formInline.promotionId + '&rechargeEndDate=' + (this.dataTime[1] || '') + '&rechargeStartDate=' + (this.dataTime[0] || '') + '&status=' + this.formInline.status + 
					'&bookName=' + this.formInline.bookName + '&tfId=' + this.formInline.tfId + '&userId=' + this.formInline.userId + '&Platform=' + localStorage.getItem('platform') + '&accountId=' + localStorage.getItem('accountId')
				window.open(url)
			} else {
				this.$message.error('没有数据');
			}
		},
		//展开、收起筛选面板
		changeCaret(value) {
			this.fromIsOpen = !value
		}
	}
}
</script>
<style lang="scss" scoped>
.media-add-ep-list {
	width: 100%;
	position: relative;
	color: #409eff;
	font-size: 14px;
	.caretbtn {
		position: absolute;
		right: 30px;
		top: 0;
		margin-left: 20px;
	}
	.from-close {
		height: 50px;
		overflow: hidden;
	}
}
.total-box{
	// padding-top: 15px;
	background: #ffffff; 
	border-top: none;
	font-size: 14px;
	color: #606266;
	margin-bottom: -20px;
}
</style>
